// eslint-disable-next-line
enum PageUrl {
  HOME = '/',
  HEALTH = '/health',
  CHECKOUT = '/checkout'
}

export default PageUrl;
